import { Navigate } from "react-router-dom";
import { useAuth, homeFor } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen ok-bg flex items-center justify-center">
        <CircleNotch size={32} className="text-primary animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
